<template>
    <Breadcrumbs main="Widgets" title="Chart" />
    <div class="container-fluid">
        <widgetCharts />
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const widgetCharts = defineAsyncComponent(() => import("@/components/theme/widgets/chart/widgetCharts.vue"))
</script>